import { useMutation } from "@tanstack/react-query";

import { updateQuoteRequestReference } from "#modules/quoteRequests/infra/updateQuoteRequestReference.api";

export const useUpdateQuoteRequestReference = () => {
  return useMutation({ mutationFn: updateQuoteRequestReference });
};
